<template>
<div id="mainBlock">
    <!-- 変更確認ポップアップの表示 -->
    <Confirm
        ref="confirm"
        @cancel="modifyStatusDelte"
        @execution="modifyStatusChange"
        :message="confirmMessage"
        :subMessage="confirmSubMessage"
        canselButtonName="キャンセル"
        executionButtonName="変更する"
    />
    <!-- エラー確認ポップアップの表示 -->
    <Alert
        ref="Alert"
        @confirmFinished="confirmFinished"
        :message="alertMessage"
        :subMessage="alertSubMessage"
        :errorFlag = "errorFlag"
    />
    <div id="blackPanel"></div>
    <article>
        <section>
            <div id="subHeader">
                <h2 v-if="siteInfo !== null">{{siteInfo[0]['site_name']}}</h2>
            </div>
            <!-- PC・タブレット用のパンくず -->
            <div v-if="!isMb && siteInfo[0].role_id==='manager'" class="breadcrumb">
                <router-link :to="routerLink" class="setting-message">設定</router-link>
                <!-- カメラ設定画面でなければaタグを活性 -->
                <a href="#" v-if="!linkDisabled" @click="cameraListsDisplay(true)" class="setting-message">カメラ設定</a>
                <p v-else class="setting-message">カメラ設定</p>
                <!-- 端末名の表示 -->
                <p v-if="!linkDisabled">{{this.cameraName}}</p>
            </div>
            <!-- モバイル用のパンくず -->
            <div v-if="isMb" class="breadcrumb-mb">
                <router-link v-if='mbPageName !== "カメラ設定"' :to="routerLink">設定</router-link>
                <a href="#" v-if='mbPageName === "カメラ設定"' @click="cameraListsDisplay(true)">カメラ設定</a>
            </div>
        </section>
        <div class="l-main" v-if="siteInfo[0].role_id==='manager'">
            <!-- カメラ詳細画面コンポーネントの呼び出し -->
            <SettingCamDetailsComponent
                v-if="cameraSettingFlg"
                ref="execModifySettingInfo"
                @cameraListsDisplay = "cameraListsDisplay"
                @displaySettingConfirm="displaySettingConfirm"
                @showResultMessage="showResultMessage"
                @settingChangeLoadStart="settingChangeLoadStart"
                @settingChangeLoadFinish="settingChangeLoadFinish"
                :cameraInfo="selectedCameraInfo"
                :siteInfo="selectedSiteInfo"
                :deviceInfo="deviceInfo"
                :timezoneInfo="timezoneInfo"
            />
            <!-- 電圧監視ウィジェット設定画面コンポーネントの呼び出し -->
            <SettingWidgetDetailsComponent
                v-if="widgetSettingFlg"
                ref="execModifyWidgetInfo"
                @widgetListsDisplay = "widgetListsDisplay"
                @loadingStarted="loadingStarted"
                @loadingFinished="loadingFinished"
                @settingChangeLoadStart="settingChangeLoadStart"
                @settingChangeLoadFinish="settingChangeLoadFinish"
                @displayWidgetConfirm="displayWidgetConfirm"
                @showResultMessage="showResultMessage"
                :cameraInfo="selectedCameraInfo"
                :siteInfo="selectedSiteInfo"
                :deviceInfo="deviceInfo"
            />
            <!-- 「カメラ詳細設定画面」と「電圧監視ウィジェット設定画面」に遷移した際に非表示状態にする -->
            <div v-if="(!cameraSettingFlg)&&(!widgetSettingFlg)" class="setting-area" id="setting-area">
                <div id="panel">
                    <p class="simple-ttl">カメラ設定</p>
                    <!-- PC・タブレット用の説明文 -->
                    <div v-if="!isMb" class="desc-wrapper">
                        <p class="simple-desc">
                            カメラの設定変更を行う場合はカメラ詳細設定の「変更」ボタンを、電圧監視設定の変更を行う場合は電圧監視設定の「変更」ボタンを、カメラに直接アクセスし設定を変更を行う場合は「操作」ボタンを押下してください。
                            <br>カメラの録画状態を変更した場合、反映までに時間がかかる場合がございます。
                        </p>
                    </div>
                    <!-- スマホ用の説明文 -->
                    <div v-if="isMb" class="desc-wrapper">
                        <p class="simple-desc">
                            カメラの設定変更を行う場合は「カメラ詳細設定」を、電圧監視の設定変更を行う場合は「電圧監視設定」を、カメラに直接アクセスし設定を変更を行う場合は「カメラ直接操作」をタップしてください。
                            <br>カメラの録画状態を変更した場合、反映までに時間がかかる場合がございます。
                        </p>
                    </div>
                </div>
                <!-- モバイル用のテーブル -->
                <div v-if="isMb || (!isTb && !isMb && windowSizeWidth < 880)" class="simple-table sp-large simple-table-mb">
                    <table>
                        <thead>
                            <tr>
                                <th v-for="list in tabledataMb" :key="list.objNum" :style="list.style" :class='"display-" + list.objNum'>
                                    <p>{{ list.name }}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(camerainfos, key) in cameraInfo" :key="camerainfos + key">
                                <td class="display-sequence-mb">
                                    <p>{{key + 1}}</p>
                                </td>
                                <td>
                                    <p class="term-id">{{ camerainfos.term_id }}</p>
                                    <p class="term-name">{{ camerainfos.description }}</p>
                                </td>
                                <td style="width:150px;">
                                    <p v-if="camerainfos.camera_host !== ''">
                                        <span v-if="camerainfos.is_recording" class="-stop -stop-mb" @click="confirmRecord('stop', camerainfos.term_id)">停止する</span>
                                        <span v-if="camerainfos.is_recording" class="recording">録画中</span>
                                        <span v-else class="-play -play-mb" @click="confirmRecord('start', camerainfos.term_id)">録画する</span>
                                        <span v-if="!camerainfos.is_recording" class="suspending">停止中</span>
                                    </p>
                                    <p v-else>
                                        <label for="">
                                        <span v-if="camerainfos.is_recording" class="-stop -stop-mb" @click="confirmRecord('stop', camerainfos.term_id)">停止する</span>
                                        <span v-if="camerainfos.is_recording" class="recording">録画中</span>
                                        <span v-else class="-play -play-mb" style="opacity:0.4;">録画する</span>
                                        (カメラURL未設定)
                                        </label>
                                        <span v-if="!camerainfos.is_recording" class="suspending">停止中</span>
                                    </p>
                                    <p>
                                        <a @click="cameraDetailDisplay(camerainfos, siteInfo[0])">カメラ詳細設定</a>
                                    </p>
                                    <p>
                                        <a @click="widgetDetailDisplay(camerainfos, siteInfo[0])">電圧監視設定</a>
                                    </p>
                                    <p>
                                        <a v-if="camerainfos.camera_host!==''" :href="camerainfos.camera_host" target="_blank" rel="noopener noreferrer">カメラ直接操作</a>
                                        <a v-else style="opacity:0.4;">操作</a>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- タブレット用のテーブル -->
                <div v-if="isTb && windowSizeWidth < 1024 || (!isTb && !isMb && windowSizeWidth < 1024 && windowSizeWidth >= 880)" class="simple-table sp-large simple-table-tb">
                    <table>
                        <thead>
                            <tr>
                                <th v-for="list in tabledataTb" :key="list.objNum" :style="list.style" :class='"display-" + list.objNum'>
                                    <p>{{ list.name }}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(camerainfos, key) in cameraInfo" :key="camerainfos + key">
                                <td class="display-sequence-tb">
                                    <p>{{key + 1}}</p>
                                </td>
                                <td class="term-id-Name">
                                    <p class="term-id">{{ camerainfos.term_id }}</p>
                                    <p class="term-name">{{ camerainfos.description }}</p>
                                </td>
                                <td>
                                    <p v-if="camerainfos.camera_host !== ''">
                                        <span v-if="camerainfos.is_recording" class="-stop -stop-tb" @click="confirmRecord('stop', camerainfos.term_id)">停止する</span>
                                        <span v-if="camerainfos.is_recording" class="recording">録画中</span>
                                        <span v-else class="-play -play-tb" @click="confirmRecord('start', camerainfos.term_id)">録画する</span>
                                        <span v-if="!camerainfos.is_recording" class="suspending">停止中</span>
                                    </p>
                                    <p v-else>
                                        <label for="">
                                        <span v-if="camerainfos.is_recording" class="-stop -stop-tb" @click="confirmRecord('stop', camerainfos.term_id)">停止する</span>
                                        <span v-if="camerainfos.is_recording" class="recording">録画中</span>
                                        <span v-else class="-play -play-tb" style="opacity:0.4;">録画する</span>
                                        (カメラURL未設定)
                                        </label>
                                        <span v-if="!camerainfos.is_recording" class="suspending">停止中</span>
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        <a @click="cameraDetailDisplay(camerainfos, siteInfo[0])">設定</a>
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        <a @click="widgetDetailDisplay(camerainfos, siteInfo[0])">設定</a>
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        <a v-if="camerainfos.camera_host!==''" :href="camerainfos.camera_host" target="_blank" rel="noopener noreferrer">操作</a>
                                        <a v-else style="opacity:0.4;">操作</a>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- PC用のテーブル -->
                <div v-if="!isTb && !isMb && windowSizeWidth >= 1024 || isTb && windowSizeWidth >= 1024" class="simple-table sp-large">
                    <table>
                        <thead>
                            <tr>
                                <th v-for="list in tabledata" :key="list.objNum" :style="list.style" :class='"display-" + list.objNum'>
                                    <p>{{ list.name }}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(camerainfos, key) in cameraInfo" :key="camerainfos + key">
                                <td class="display-sequence">
                                    <p>{{camerainfos.sort === "0" ? "" : camerainfos.sort}}</p>
                                </td>
                                <td class="display-termId">
                                    <p>{{ camerainfos.term_id }}</p>
                                </td>
                                <td class="term-name">
                                    <p>{{ camerainfos.description }}</p>
                                </td>
                                <td style="width:150px;">
                                    <p v-if="camerainfos.camera_host !== ''">
                                        <span v-if="camerainfos.is_recording" class="-stop" @click="confirmRecord('stop', camerainfos.term_id)">停止する</span>
                                        <span v-if="camerainfos.is_recording" class="recording">録画中</span>
                                        <span v-else class="-play" @click="confirmRecord('start', camerainfos.term_id)">録画する</span>
                                        <span v-if="!camerainfos.is_recording" class="suspending">停止中</span>
                                    </p>
                                    <p v-else>
                                        <label for="">
                                        <span v-if="camerainfos.is_recording" class="-stop" @click="confirmRecord('stop', camerainfos.term_id)">停止する</span>
                                        <span v-if="camerainfos.is_recording" class="recording">録画中</span>
                                        <span v-else class="-play" style="opacity:0.4;">録画する</span>
                                        (カメラURL未設定)
                                        </label>
                                        <span v-if="!camerainfos.is_recording" class="suspending">停止中</span>
                                    </p>
                                </td>
                                <td style="width:150px;">
                                    <p>
                                        <a class="td-change-btn" @click="cameraDetailDisplay(camerainfos, siteInfo[0])">変更</a>
                                    </p>
                                </td>
                                <td style="width:150px;">
                                    <p>
                                        <a class="td-change-btn" @click="widgetDetailDisplay(camerainfos, siteInfo[0])">変更</a>
                                    </p>
                                </td>
                                <td style="width:150px;">
                                    <p>
                                        <a v-if="camerainfos.camera_host!==''" :href="camerainfos.camera_host" target="_blank" rel="noopener noreferrer">操作</a>
                                        <a v-else style="opacity:0.4;">操作</a>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </article>
</div>
</template>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;

import SettingCamDetailsComponent from './SettingCamDetailsComponent'
import SettingWidgetDetailsComponent from './SettingWidgetDetailsComponent'
import isMobile from '../../js/modules/componentDeviceUtility.js'
import Confirm from '../modal/Confirm'
import Alert from '../modal/Alert'
const logoutUrl = process.env.VUE_APP_LOGOUT;

export default {
    name: 'SettingCamListsComponent',
    data(){
        return {
            // 設定画面>カメラ一覧のテーブル項目（PC用）
            tabledata: [
              {objNum:1, name:'表示順', style:'min-width:65px; width:80px;'},
              {objNum:2, name:'端末ID', style:'min-width:70px; width:100px;'},
              {objNum:3, name:'カメラ名称', style:'min-width:160px;'},
              {objNum:7, name:'録画中 / 停止中', style:'min-width:125px;'},
              {objNum:8, name:'カメラ詳細設定', style:'min-width:125px;'},
              {objNum:9, name:'電圧監視設定', style:'min-width:125px;'},
              {objNum:10, name:'カメラ直接操作', style:'min-width:125px;'},
            ],
            // 設定画面>カメラ一覧のテーブル項目（タブレット用）
            tabledataTb: [
              {objNum:2, name:'端末ID / カメラ名称', },
              {objNum:7, name:'録画中 / 停止中', style:'width:120px;'},
              {objNum:8, name:'カメラ詳細', style:'width:120px;'},
              {objNum:9, name:'電圧監視', style:'width:120px;'},
              {objNum:10, name:'カメラ直接操作', style:'width:120px;'},
            ],
            // 設定画面>カメラ一覧のテーブル項目（スマホ用）
            tabledataMb: [
              {objNum:2, name:'端末ID / カメラ名称', style:'min-width:100px;'},
              {objNum:7, name:'設定', style:'min-width:150px;'},
            ],
            // カメラ詳細設定画面を表示/非表示するための判断フラグ
            cameraSettingFlg: false,
            // 電圧監視ウィジェット設定画面を表示/非表示するための判断フラグ
            widgetSettingFlg: false,
            selectedCameraInfo: null,
            selectedSiteInfo: null,
            // APIをコールする際に一時的にバッファする
            infoCallingApi: null,
            deviceInfo: null,
            timezoneInfo: null,
            // ローディング画面を表示するための値
            is_show: false,
            // 子コンポーネントから確認ポップアップ表示が着火されて、どこの子コンポーネントから呼び出されたのか判定するためのフラグ
            // 1: SettingCamDetailsComponent.vueからの呼び出し、2:SettingWidgetDetailsComponent.vueからの呼び出し
            settingConfirmDisplayFlg: 0,

            // 子コンポーネントからの呼び出しで、確認する対象（録画ボタン確認や設定変更確認）によって表示文言を変更するための値
            confirmMessage: "",
            confirmSubMessage: "",
            routerLink: '/settings?site_no=' + this.$store.getters['auth/getSiteNo'],

            // 子コンポーネントからの呼び出しで、録画状態を管理するためのフラグ
            recordStatusFlg: "",

            // カメラ一覧画面から録画・停止を選択した端末を格納
            selectedTermId: "",
            // エラーメッセージ用の変数
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false,

            conrfirmResult: {},
            // 非同期処理で呼び出したapiのカウント用の変数
            apiCnt: 0,
            // スマホ判定用の変数
            isMb: isMobile.isMobile(),
            // タブレット判定用の変数
            isTb: isMobile.isTablet(),
            // パンくずのaタグの活性/非活性を操作（初期は"カメラ設定"を表示）
            linkDisabled: true,
            // パンくずで表示する端末名を格納
            cameraName: "",
            // スマホ用のパンくずで表示する文言を判定するための変数
            mbPageName: "",
            // ウィンドウのサイズを保持するために使用
            windowSizeWidth: window.innerWidth,
        }
    },
    props:{
        siteInfo:{
            type: Array
        },
        cameraInfo:{
            type: Array
        }
    },
    components: {
        SettingCamDetailsComponent,
        SettingWidgetDetailsComponent,
        Confirm,
        Alert,
    },
    methods: {
        //**********************************************************/
        // 変更確認ポップアップの表示後、キャンセルを押した場合の処理
        /**********************************************************/
        modifyStatusDelte: function () {
            // 以下、録画状態や設定画面の状態の有無を管理しているフラグを初期化する処理
            this.settingConfirmDisplayFlg = 0;
            this.recordStatusFlg = ""
        },
        //**********************************************************/
        // 変更確認ポップアップの表示後、適用された後の処理実行とポップアップ非表示処理
        /**********************************************************/
        modifyStatusChange: function () {
            // 録画状態変更確認をした際に発火する処理の条件分岐
            if(this.recordStatusFlg !== "" && this.selectedTermId !== ""){
              // 子コンポーネントの録画停止/開始処理を実行
              this.recordSwicher(this.recordStatusFlg);
            }
            // 設定画面変更（電圧監視ウィジェットの設定なども含む）確認をした際に発火する処理の条件分岐
            else{
                if(this.settingConfirmDisplayFlg === 1){
                    // 子コンポーネントの設定変更処理を実行
                    this.$refs.execModifySettingInfo.modifySettingStatusChange();
                }else if(this.settingConfirmDisplayFlg === 2){
                    // 子コンポーネントの電圧監視ウィジェット設定変更処理を実行
                    this.$refs.execModifyWidgetInfo.modifyWidgetStatusChange();
                }
            }
            // 確認ポップアップ非表示
            this.$refs.confirm.hiddenConfirm();
            // ローディングスタート
            this.$emit('loadStart');

            // 以下、録画状態や設定画面の状態を管理しているフラグを初期化する処理
            this.settingConfirmDisplayFlg = 0;
            this.recordStatusFlg = ""
        },
        //**********************************************************/
        // 設定画面変更確認ポップアップの表示のための処理
        /**********************************************************/
        displaySettingConfirm: async function(){
            this.settingConfirmDisplayFlg = await 1;
            this.confirmMessage = await "設定更新";
            this.confirmSubMessage = await "設定を変更します。よろしいですか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 電圧監視ウィジェット設定変更確認ポップアップの表示のための処理
        /**********************************************************/
        displayWidgetConfirm: async function(){
            this.settingConfirmDisplayFlg = await 2;
            this.confirmMessage = await "設定更新";
            this.confirmSubMessage = await "設定を変更します。よろしいですか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 録画停止開始処理を確認するための確認ポップアップ表示処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        // 引数
        // recordStatus: 録画状態を管理しているステータス
        /**********************************************************/
        confirmRecord: function(recordStatus, termId){
            this.selectedTermId = termId;
            if(recordStatus === "start"){
                this.displayRecordConfirmStart();
            }else{
                this.displayRecordConfirmStop();
            }
        },
        //**********************************************************/
        // 録画開始処理確認ポップアップの表示のための処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        displayRecordConfirmStart: async function(){
            this.recordStatusFlg = await "start"
            this.confirmMessage = await "録画状態変更";
            this.confirmSubMessage = await "録画を開始します。よろしいですか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 録画停止処理確認ポップアップの表示のための処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        displayRecordConfirmStop: async function(){
            this.recordStatusFlg = await "stop"
            this.confirmMessage = await "録画状態変更";
            this.confirmSubMessage = await "録画を停止します。よろしいですか？";
            // 確認ポップアップ表示
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 録画開始停止処理
        /**********************************************************/
        // 引数
        // recordType: 録画停止開始処理のタイプ
        /**********************************************************/
        recordSwicher: async function(recordStatus){
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            // 録画停止開始のための条件分岐
            if(recordStatus === "start"){
                // 録画開始APIをコール
                await this.callApiForInfo('recorder/' + this.siteInfo[0].site_no + '/' + this.selectedTermId + '/status', "put", queries)
            }else{
                // 録画停止APIをコール
                this.callApiForInfo('recorder/' + this.siteInfo[0].site_no + '/' + this.selectedTermId + '/status', "delete", queries)
            }
        },
        //**********************************************************/
        // 録画開始・録画停止用API実施
        /**********************************************************/
        callApiForInfo: async function(param, method, queries){
            // 関数return値を配置する変数
            var isApiData = "";
            await this.$store.dispatch('requestApi/' + method + 'ApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            // 以下「eslint-disable-line」を使用することにより、不要なバリデーションを除外する
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/' + method + 'ApiInfo'];
                isApiData = this.infoCallingApi;

                // ローディングストップ
                this.$emit('loadFinish');

                if (method === 'put') {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: true,
                        message:"録画成功",
                        sub_message:"録画を開始しました。",
                        errorFlag: false
                    });
                } else if (method === 'delete') {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: true,
                        message:"録画停止成功",
                        sub_message:"録画を停止しました。",
                        errorFlag: false
                    });
                }
            }, error => {// eslint-disable-line
                // ローディングストップ
                this.$emit('loadFinish');
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    if (method === 'put') {
                        this.showResultMessage({
                            transitionLogoutPageFlg: false,
                            transitionTopPageFlg: false,
                            execFlg: false,
                            message:"録画失敗",
                            sub_message:"録画を開始できませんでした。カメラURLをご確認ください。",
                            errorFlag: true
                        });
                    } else if (method === 'delete') {
                        this.showResultMessage({
                            transitionLogoutPageFlg: false,
                            transitionTopPageFlg: false,
                            execFlg: false,
                            message:"録画停止失敗",
                            sub_message:"録画を停止できませんでした。カメラURLをご確認ください。",
                            errorFlag: true
                        });
                    }
                }
            })
            return isApiData
        },
        //**********************************************************/
        // routerをリロードする処理
        // 【TODO】カメラ詳細設定のほうの録画処理を削除後にリファクタリングすること
        /**********************************************************/
        loadBrowser: function(){
            window.location.href = "./camera?site_no=" + this.$store.getters['auth/getSiteNo'];
        },
        /****************************************************************/
        // サムネイルを全て読み込み後にローディングを開始する処理
        /****************************************************************/
        loadingStarted(){
            this.$emit('loadStart');
            document.getElementById('l-main').style.display = "none"
        },
        /****************************************************************/
        // サムネイルを全て読み込み後にローディングを終了する処理
        /****************************************************************/
        loadingFinished(){
            this.$emit('loadFinish');
            document.getElementById('l-main').style.display = "inherit"
        },
        /****************************************************************/
        // 子に渡すようのローディングを開始する処理
        /****************************************************************/
        settingChangeLoadStart() {
            this.$emit('loadStart');
        },
        /****************************************************************/
        // 子に渡すようのローディングを終了する処理
        /****************************************************************/
        settingChangeLoadFinish() {
            this.$emit('loadFinish');
        },
        //**********************************************************/
        // カメラ設定詳細画面を表示するための関数
        // SettingCamDetailsComponentコンポーネントを表示するためにFlgを変更 & SettingCamDetailsComponentコンポーネントに引数情報を受け渡す
        /**********************************************************/
        cameraDetailDisplay(camerainfos, siteinfos){
            this.mbPageName = "カメラ設定";
            this.linkDisabled = false;
            this.cameraName = camerainfos.description;
            this.cameraSettingFlg   = true;
            this.selectedCameraInfo = camerainfos;
            this.selectedSiteInfo   = siteinfos;
        },
        //**********************************************************/
        // カメラ設定詳細画面からカメラ設定一覧画面に戻るために着火する関数（SettingCamDetailsComponentコンポーネントから呼び出される）
        // SettingCamDetailsComponentコンポーネントからのみ実行できるように引数情報を条件に内容着火
        /**********************************************************/
        cameraListsDisplay(execFlg){
            if(execFlg){
                this.mbPageName = "";
                this.cameraName = "";
                this.linkDisabled = true;
                this.cameraSettingFlg = false
                this.widgetSettingFlg = false
            }
        },
        //**********************************************************/
        // 電圧監視ウィジェット設定画面を表示するための関数
        // SettingWidgetDetailsComponentコンポーネントを表示するためにFlgを変更 & SettingWidgetDetailsComponentコンポーネントに引数情報を受け渡す
        /**********************************************************/
        widgetDetailDisplay(camerainfos, siteinfos){
            this.mbPageName = "カメラ設定";
            this.linkDisabled = false;
            this.cameraName = camerainfos.description;
            this.widgetSettingFlg   = true;
            this.selectedCameraInfo = camerainfos;
            this.selectedSiteInfo   = siteinfos;
        },
        //**********************************************************/
        // 電圧監視ウィジェット設定画面からカメラ設定一覧画面に戻るために着火する関数（SettingWidgetDetailsComponentコンポーネントから呼び出される）
        // SettingWidgetDetailsComponentコンポーネントからのみ実行できるように引数情報を条件に内容着火
        /**********************************************************/
        widgetListsDisplay(execFlg){
            if(execFlg){
                this.mbPageName = "";
                this.cameraName = "";
                this.linkDisabled = true;
                this.widgetSettingFlg = false
                this.cameraSettingFlg = false
            }

        },
        //**********************************************************/
        // 機種情報取得APIの実施
        /**********************************************************/
        callApiForGetDevicesInfo: async function(param){
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/getApiInfo'];
                this.deviceInfo = this.infoCallingApi;
                this.apiCnt++;
            }, error => {// eslint-disable-line
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"カメラ詳細情報取得エラー",
                        sub_message:"カメラ詳細情報の取得に失敗しました。",
                        errorFlag: true
                    });
                }
            })
        },
        //**********************************************************/
        // タイムゾーン情報取得APIの実施
        /**********************************************************/
        callApiForGetTimezoneInfo: async function(param){
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/getApiInfo'];
                this.timezoneInfo = this.infoCallingApi;
                this.apiCnt++;
            }, error => {// eslint-disable-line
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"カメラ詳細情報取得エラー",
                        sub_message:"カメラ詳細情報の取得に失敗しました。",
                        errorFlag: true
                    });
                }
            })
        },
        //**********************************************************/
        // 確認モーダル処理
        /**********************************************************/
        confirmFinished: function() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg === true) {
                this.loadBrowser();
            }
        },
        //**********************************************************/
        // 確認モーダル用のデータの受け渡し
        /**********************************************************/
        showResultMessage: function(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        //**********************************************************/
        // 画面がリサイズされたらウィンドウの横幅を取得する
        /**********************************************************/
        handleResize: function() {
            this.windowSizeWidth = window.innerWidth;
        },
    },
    watch: {
        apiCnt: {
            handler: function() {
                if(this.apiCnt === 2) {
                    document.getElementById('setting-area').style.display = "inherit"
                    this.$emit('loadFinish');
                }
            }
        }
    },
    created: function() {
        this.$emit('loadStart');
    },
    mounted: async function() {
        //**********************************************************/
        // 権限がない場合にログアウト画面にリダイレクトする処理
        /**********************************************************/
        if(!this.$userRoleAuthorization('setting', 'settingCamLists')){
            // ローディングストップ
            this.$emit('loadFinish');
            this.showResultMessage({
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: true,
                execFlg: false,
                message:"権限エラー",
                sub_message:"アクセス権がありません。",
                errorFlag: true
            });
        //**********************************************************/
        // 権限がある場合に機種情報とタイムゾーン情報を取得する
        /**********************************************************/
        } else {
            // 機種情報などを取得してくるAPIを実施
            this.callApiForGetDevicesInfo('devices');
            // タイムゾーン情報などを取得してくるAPIを実施
            this.callApiForGetTimezoneInfo('timezone');
        }
        //**********************************************************/
        // resizeイベントが動作するときに実行する関数を登録(windowサイズを動的に取得)
        /**********************************************************/
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main/SettingCamListsComponent.css";
</style>